import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  from
} from '@apollo/client';

import { onError } from '@apollo/client/link/error';

import * as Sentry from '@sentry/react';

import { ApolloTypePolicies, ClientSideSchema } from './apollo-type-policies';
import { ApolloFragmentRegistry } from './apollo-fragment-registry';

import { AUTH_TOKEN, GRAPHQL_API } from '../constants';

const httpLink = new HttpLink({ uri: GRAPHQL_API });

const errorControl = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      Sentry.captureException(graphQLErrors);
      if (process.env.NODE_ENV === 'development') {
        // Adds messages only in a dev environment
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );
      }
    });
  }
  if (networkError) {
    Sentry.captureException(networkError);
    if (process.env.NODE_ENV === 'development') {
      // Adds messages only in a dev environment
      console.log(`[Network error]: Message: ${networkError}`);
    }
  }
});

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: localStorage.getItem(AUTH_TOKEN) || null
    }
  });
  return forward(operation);
});

export const client = new ApolloClient({
  link: from([errorControl, authMiddleware, httpLink]),
  cache: new InMemoryCache({
    ...ApolloFragmentRegistry,
    typePolicies: ApolloTypePolicies,
    typeDefs: ClientSideSchema
  })
});
